/**
 * @param {Phaser.Scene} scene
 */
 export const createBg = (scene, width, height) => {
    let bg0 = scene.add
      .image(0, 0, "bg0")
      .setOrigin(0)
      .setDisplaySize(width, height);
  
    const groupTemplate = (bgImage, y, originY) => {
      let bg = scene.physics.add
        .group([
          scene.physics.add.image(0, y, bgImage).setDisplaySize(width, height),
          scene.physics.add
            .image(width, y, bgImage)
            .setDisplaySize(width, height),
        ])
        .setOrigin(0, originY);
      return bg;
    };
    let bg1 = groupTemplate("bg1", 0, 0);
    let bg2 = groupTemplate("bg2", 0, 0);
    let bg3 = groupTemplate("bg3", 0, 0);
    let bg4 = groupTemplate("bg4", height, 1);
    return [bg0, bg1, bg2, bg3, bg4];
  };

/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Sprite} bg1
 * @param {Phaser.Physics.Arcade.Sprite} bg2
 * @param {Phaser.Physics.Arcade.Sprite} bg3
 * @param {Phaser.Physics.Arcade.Sprite} bg4
 */
 export const moveBg = (scene, bg1, bg2, bg3, bg4, scaleX, width, speedFactor) => {
    const template = (bg, speed) => {
      bg.setVelocityX(speed * scaleX * speedFactor);
      bg.getChildren().forEach((child) => {
        if (child.getBounds().right <= 0) {
          child.x = width + child.getBounds().right;
        }
      });
    };
    template(bg1, -150);
    template(bg2, -250);
    template(bg3, -350);
    template(bg4, -450);
  };
  